<template>
     <div class="d-flex flex-column full-height topBk">
    <nav id="navbar" style="background: transparent">
        <div class="d-flex justify-content-between align-items-center m-1">
          <div @click="direct_home" class="hand">
            <div  class="d-flex justify-content align-items-center">
             <span class="navTitle">两棵树</span><img src="../assets/logo-ai.svg" class="logo">
            </div>
            
          </div>
          
        <div v-if="logined" class="btn" @click="relogin">退出</div>
   
      </div>
     
    </nav>

    <div class="d-flex flex-column full-width ">
    <div class="full-width d-flex align-items-center full-height">
        <div class="container">
           
            <div class="d-flex justify-content-center align-items-center flex-column" >
                <div>
                    <div class="topTitle fontColor">两棵树<img src="../assets/logo-ai.svg"></div>
                    <div class="title mt-2 fontColor">全自动小红书运营工具</div>
                    <div class="topFont mt-2 fontColor">
                    365天日更小红书，仅需1分钟！
                    </div>

                    <div class="btn normalBtn mt-4"  @click="login">立即体验-></div>
                </div>
               
        </div>
        </div>
    </div>

    <div class="mt-3 mb-2">
        <div class="d-flex justify-content-center flex-column">
          
            <div class=" d-flex justify-content-center copy">扫码添加客服微信，关注公众号</div>
            <div class="mt-1 mb-1  d-flex justify-content-center">
                <img class="kefu" src="../assets/kefu.png">
                <img class="qr ml-1" src="../assets/gzh.jpg">
            </div>
            <div class="copy d-flex justify-content-center">Copyright@北京双树智能科技有限公司<a class="copy" href="https://beian.miit.gov.cn/">京ICP备2024075769号-1</a></div>
           
        </div>
        
    </div>
</div>
</div>

</template>
<script>
import moment from 'moment';
import axios from 'axios';
export default({
    data(){
        return {
      role:0,
      needLogin:false,
      router:'account',
      showqr:false,
      promotion_qr:null,
      logined:false,
      unionId:null
    };
    },
    setup() {
        
    },
    components: {
    // AccountPageVue
  },
    mounted(){
      // localStorage.setItem('sessionToken','r:43aefd6290e5243a65646f8182d454fc');
      //  localStorage.setItem('role',1);

       const code = this.$route.query.code
       
       localStorage.setItem('user_code',code)
       console.log(code)

       this.unionId=this.$route.query.unionId
       console.log(this.unionId)

       this.direct_home()

       

       
    },
    computed: {
     localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD');
         return beijingTime
         
       }
     },
     
     formatDate(){
      return (datetimeString) => {
        console.log(datetimeString)
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     }


   },

    methods:{
      async login_by_unionId(){
      try{

        const response = await axios.get(this.domain+'xhs/unionid_login?unionId='+this.unionId);

        var data=response.data
        if(data.status=='Suc')
        {
            if(data['session']!=undefined)
            {
              localStorage.setItem('sessionToken', response.data['session']);
              localStorage.setItem('role', response.data['role']);
            }
            // this.$emit('login_suc', true);
            this.$router.push('/index/user')
            
           
        }
        else
        {
            console.error(data)
            
        }
      }
      catch(error)
      {
          console.error(data)
      }
    


        
      },

      direct_home(){
      var token=localStorage.getItem('sessionToken');
        this.role=localStorage.getItem('role');

          if(token==undefined || token==null ||token=='')
          {
            if(this.unionId!=undefined)
            {
              this.login_by_unionId()
            }
            else
            {
              this.logined=false
              this.$router.push('/home')
            }
            
            
            // this.needLogin=true
          }
          else
          {
            this.logined=true
            this.$router.push('/index/user')
           
            // this.needLogin=false;
          }
    },

        login(){
        this.$router.push('/login')
    },
    handleLogin(){
      console.log('logined')
      this.needLogin=false
      // this.$router.push('/index')
      this.$router.go(0)
    },
      
    }
})
</script>
<style scoped>
.btn{
    background-color:#ec2151 ;
    border:0;
    width: max-content;
    color:white;
    padding:0.3rem 0.6rem 0.3rem 0.6rem;
    font-size: 0.5rem;
    font-weight: 700;
}
.logo{
  height:0.4rem
}
.fontColor
{
   color: #000000 ;
}
.navTitle{
    font-size: 0.3rem;
    font-style: normal;
    font-weight: 800;
}
.topTitle{
  
  
    font-size: 0.7rem;
    font-style: normal;
    font-weight: 700;
    line-height:0.7rem;
}
.title{
   
    font-size: 1rem;
    font-weight: 900;
}
.topFont{
 font-size: 0.5rem;
 font-style: normal;
}

.productSection{
    background:white
}


.cover{
    width:100%;
border-radius: 0.15rem;
}
.date{
    color: #3b64ff;
 font-family: "Poppins";
 font-size: 0.15rem;
 font-style: normal;
 font-weight: 500;

}
.icon{
  width:0.175rem;
  height:0.175rem;
}
.countFont{
    color: #858396;
 font-family: "Poppins";
 font-size:0.1625rem;
 font-style: normal;
 font-weight: 500;
 line-height: 0.275rem;
}


.qr{
    width:1.5rem;
    height:1.5rem
}
.kefu{
    width:1.3rem;
    height:1.3rem;
    margin-top:0.1rem;
}
.copy{
    font-size:0.175rem;
    color:black
}
</style>
